import React from "react";

const LABELS = {
  signup: {
    desktop: ["Step 1 of 3 · Your details", "Step 2 of 3 · Verify email", "Step 3 of 3 · About your team · Optional", "All set"],
    mobile: ["Step 1 of 3 · Your details", "Step 2 of 3 · Verify", "Step 3 of 3 · Optional", "All set"],
  },
  signin: {
    desktop: ["Step 1 of 2 · Your email", "Step 2 of 2 · Verify email"],
    mobile: ["Step 1 of 2 · Your email", "Step 2 of 2 · Verify"],
  },
};

const AuthCard = ({ flow, stepIndex, mobile, short, roomy, children }) => {
  const railCount = flow === "signup" ? 3 : 2;
  return (
    <div
      style={{
        position: "relative",
        zIndex: 2,
        boxSizing: "border-box",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        border: "1px solid rgba(255,255,255,.85)",
        borderRadius: 24,
        ...(mobile
          ? {
              width: "100%",
              maxWidth: 480,
              padding: "20px 18px 18px",
              background: "#fff",
              boxShadow: "0 24px 50px -24px rgba(58,20,73,.35),0 1px 3px rgba(58,20,73,.08)",
            }
          : {
              width: roomy ? 480 : 430,
              padding: roomy ? "40px 44px 34px" : short ? "24px 32px 22px" : "32px 36px 28px",
              background: "rgba(255,255,255,.8)",
              boxShadow: "0 30px 60px -30px rgba(90,32,90,.35),0 2px 6px rgba(90,32,90,.06)",
            }),
      }}
    >
      <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
        {Array.from({ length: railCount }, (_, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: 3,
              borderRadius: 2,
              transition: "background .4s",
              background: i <= Math.min(stepIndex, railCount - 1) ? "linear-gradient(90deg,#C95EBE,#8B55DD)" : "rgba(0,0,0,.10)",
            }}
          />
        ))}
      </div>
      <p
        style={{
          margin: `0 0 ${mobile || short ? 14 : 22}px`,
          fontSize: 11.5,
          fontWeight: 600,
          letterSpacing: ".08em",
          textTransform: "uppercase",
          color: "#A38AAB",
        }}
      >
        {LABELS[flow][mobile ? "mobile" : "desktop"][stepIndex]}
      </p>
      {children}
    </div>
  );
};

export default AuthCard;
